// third-party
import { FormattedMessage } from 'react-intl';

// assets
import { Buliding } from 'iconsax-react';

// type
import { NavItemType } from 'types/menu';

// icons
const icons = { Buliding };

// ==============================|| MENU ITEMS - category ||============================== //

const TrainingCenter: NavItemType = {
  id: 'TrainingCenter',
  type: 'group',
  icon: icons.Buliding,
  name: 'TrainingCenter',
  children: [
    {
      icon: icons.Buliding,
      id: 'trainingcenter',
      title: <FormattedMessage id="TrainingCenter" />,
      type: 'item',
      url: '/trainingcenter'
    }
  ]
};

export default TrainingCenter;
